<template>
    <div
        class="lsva-trucks-view"
        :class="{
            'lsva-trucks-view--splitted': selectedTruck,
        }"
    >
        <div class="lsva-trucks-view__filters">
            <LsvaCalendarFilter>
                <template #center>
                    <BaseButton size="small" @click="showModal">
                        <template #icon>
                            <InfoIcon
                                color="currentColor"
                                width="1em"
                                height="1em"
                            />
                        </template>
                        {{ $t('newUiButton') }}
                    </BaseButton>
                </template>
            </LsvaCalendarFilter>
        </div>

        <div class="lsva-trucks-view__split">
            <LsvaOverviewTrucksTableView
                class="lsva-trucks-view__table"
                :filter-search="filterSearch"
                :filter-status="filterStatus"
                @clearFilter="clearFilter"
            >
                <template #filter>
                    <LsvaTrucksFilter />
                </template>
            </LsvaOverviewTrucksTableView>

            <LsvaTruckDetailsView
                v-if="selectedTruck"
                :truck="selectedTruck"
                class="lsva-trucks-view__form"
                @close="handleCloseTruckDetails"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import LsvaCalendarFilter from '@/components/lsva/LsvaCalendarFilter'
import LsvaOverviewTrucksTableView from './LsvaOverviewTrucksTableView'
import LsvaTruckDetailsView from '@/components/views/lsva/LsvaTruckDetailsView'
import LsvaTrucksFilter from '@/components/lsva/LsvaTrucksFilter'
import BaseButton from '@/components/redesigned/BaseButton'
import InfoIcon from '@/components/icons/InfoIcon.vue'

const LsvaChangesModal = () => import('../../lsva/LsvaChangesModal.vue')

export default {
    name: 'LsvaOverviewView',
    components: {
        LsvaCalendarFilter,
        LsvaOverviewTrucksTableView,
        LsvaTruckDetailsView,
        LsvaTrucksFilter,
        BaseButton,
        InfoIcon,
    },
    data() {
        return {
            filterSearch: '',
            filterStatus: [],
        }
    },
    computed: {
        ...mapState('lsva', ['selectedTruck']),
        ...mapGetters('preferences', ['userInteractionPreferences']),
    },
    mounted() {
        this.loadTrailers()
        if (!this.userInteractionPreferences.hideLsvaOverviewOnboardingPopup) {
            this.showModal()
        }
    },
    methods: {
        ...mapActions('lsva', [
            'loadTrailers',
            'setSelectedDay',
            'setSelectedTruck',
        ]),
        ...mapActions('preferences', ['updatePreferences']),
        clearFilter() {
            this.filterSearch = ''
            this.filterType = []
        },
        handleCloseTruckDetails() {
            this.setSelectedTruck(null)

            const newQuery = {
                ...this.$route.query,
            }
            delete newQuery.selected_declaration

            this.$router.push({
                query: newQuery,
            })
        },
        showModal() {
            this.$modal.show(
                LsvaChangesModal,
                {},
                {
                    width: '50%',
                    height: '50%',
                }
            )

            this.updatePreferences({
                userInteractionPreferences: {
                    hideLsvaOverviewOnboardingPopup: true,
                },
            })
        },
    },
}
</script>

<i18n>
{
    "en": {
        "filterByColor": "Color",
        "filterByLocation": "Location",
        "filterByMeasurements": "Filter by measurements",
        "filterByQuery": "Name",
        "filterByType": "Type",
        "share": "Share",
        "newUiButton": "Info about the new interface"
    },
    "de": {
        "filterByColor": "Farbe",
        "filterByLocation": "Standort",
        "filterByMeasurements": "Filtern nach Messungen",
        "filterByQuery": "Name",
        "filterByType": "Typ",
        "share": "Teilen",
        "newUiButton": "Info zur neuen Ansicht"
    },
    "fr": {
        "filterByColor": "Couleur",
        "filterByLocation": "Emplacement",
        "filterByMeasurements": "Filtrer par mesures",
        "filterByQuery": "Nom",
        "filterByType": "Type",
        "share": "Partager",
        "newUiButton": "Info sur la nouvelle interface"
    },
    "it": {
        "filterByColor": "Colore",
        "filterByLocation": "Locazione",
        "filterByMeasurements": "Filtro per misurazioni",
        "filterByQuery": "Name",
        "filterByType": "Typo",
        "share": "Condividi",
        "newUiButton": "Info sulla nuova interfaccia"
    }
}
</i18n>

<style lang="scss" scoped>
.lsva-trucks-view {
    $self: &;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    &__filters {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 1.5rem 2rem;
        background-color: $color-gray-lighter-new;
        border-bottom: $style-border;

        .base-input,
        .multiselect {
            max-width: 200px;
        }
    }

    &__split {
        position: relative;
        display: flex;
        width: 100%;
        height: 100%;
        overflow-y: auto;

        & > div {
            width: 375px;
            height: 100%;
            overflow-y: auto;
        }

        #{$self}__table {
            width: 100%;
        }
    }

    &--splitted {
        #{$self}__table {
            width: calc(100% - 375px);
        }

        #{$self}__form {
            border-left: $style-border;
        }
    }

    @include respond-to('for-mobile-down') {
        &__split {
            flex-direction: column-reverse;

            & > div {
                width: 100% !important;
                height: auto;
                border-left: none !important;
                flex: 1 0 100%;
            }
        }

        &__split-icon {
            display: inline-block;
        }

        &--splitted {
            #{$self}__form {
                display: block;
            }

            #{$self}__table {
                display: none;
            }
        }
    }

    @include respond-to('for-small-mobile-only') {
        &__filters {
            padding: 1rem;

            & > * {
                &:not(.base-button) {
                    margin-right: 0;
                    max-width: 100%;
                    width: 100%;
                }
            }
        }
    }
}
</style>
